<template>
  <div class="mt-5 pt-5">
    <div class="container-fluid p-0">
      <div class="row justify-content-center pt-5">
        <h3 class="Header__title">
          {{ $t("Kontaktformular") }}
        </h3>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-4 t-center p-4">
          <hr />
        </div>
      </div>
      <div class="contact_form pb-5">
        <div class="row justify-content-center">
          <div class="col-md-8 pt-3">
            <div class="row justify-content-center whi">
              <div class="col-md-4"></div>
              <div class="col-md-6">
                <span class="required_notification">{{
                  $t("* notwendige Eingaben")
                }}</span>
              </div>
            </div>
            <div class="row justify-content-center whi">
              <div class="col-md-8">
                <p>
                  {{ $t("Hier können Sie ganz einfach mit uns den Kontakt aufnehmen.") }}
                </p>
                <p>
                  {{
                    $t(
                      "Wir melden uns so schnell wie möglich bei Ihnen zurück. Wenn Sie uns"
                    )
                  }}
                  {{ $t("Ihre Telefonnummer verraten, auch auf diesem Weg.") }}
                </p>
              </div>
            </div>
            <div class="row align-items-center justify-content-center">
              <div class="col-12 col-lg-6">
                <div class="input-group mb-3">
                  <span class="input-group-text mailtext" id="basic-addon1"
                    >{{ $t("Name*") }}:</span
                  >
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Name"
                    v-model="mail.name"
                    v-bind:class="background.name"
                  />
                </div>
              </div>
            </div>
            <div class="row align-items-center justify-content-center">
              <div class="col-12 col-lg-6">
                <div class="input-group mb-3">
                  <span class="input-group-text mailtext" id="basic-addon1"
                    >{{ $t("Email*") }}:</span
                  >
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Email"
                    v-model="mail.email"
                    v-bind:class="background.email"
                  />
                </div>
                <p v-if="!isValidEmail && mail.email" class="text-danger">
                  {{ $t("Ungültige E-Mail-Adresse") }}
                </p>
              </div>
            </div>
            <!-- Telefon -->
            <div class="row align-items-center justify-content-center">
              <div class="col-12 col-lg-6">
                <div class="input-group mb-3">
                  <span class="input-group-text mailtext" id="basic-addon1"
                    >{{ $t("Telefon") }}:</span
                  >
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Telefon"
                    v-model="mail.telefon"
                  />
                </div>
              </div>
            </div>
            <!-- Telefon -->
            <div class="row align-items-center justify-content-center">
              <div class="col-12 col-lg-6">
                <div class="input-group mb-3">
                  <span class="input-group-text mailtext" id="basic-addon1"
                    >{{ $t("Nachricht") }}:</span
                  >
                  <textarea
                    name="message"
                    class="form_message_Field"
                    rows="5"
                    v-model="mail.message"
                    v-bind:class="background.message"
                  >
                  </textarea>
                </div>
              </div>
            </div>

            <div class="row justify-content-center mb-3">
              <div class="col-12 col-lg-8">
                <input
                  type="checkbox"
                  name="datenschutz"
                  class="checkbox"
                  v-model="mail.datenschutz"
                  v-bind:class="background.datenschutz"
                /><span
                  class="ps-5 checkboxLabel"
                  v-bind:class="background.datenschutz"
                  for="email"
                >
                  *{{ $t("Die Angaben zum") }}
                  <router-link to="/Datenschutz" class="">{{
                    $t("Datenschutz")
                  }}</router-link>
                  {{ $t("habe ich gelesen .") }}
                </span>
              </div>
            </div>
          </div>
          <div class="row justify-content-center whi">
            <div class="col-12 col-lg-4 d-grid gap-2">
              <button type="button" class="btn btn-primary" @click="sendMail()">
                {{ $t("Anfragesenden") }}
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              {{ mail.gesendet }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import { mapGetters } from "vuex";

import axios from "axios";

export default {
  name: "KontaktPage",

  data() {
    return {
      newSite: null,
      visi: false,
      mail: {
        name: "",
        email: "",
        message: "",
        telefon: "",
        datenschutz: false,
        gesendet: "",
      },
      background: {
        name: "",
        email: "",
        message: "",
        datenschutz: "",
      },
    };
  },
  components: {},

  computed: {
    isValidEmail() {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(this.mail.email);
    },
  },
  methods: {
    checkEingaben() {
      let re = true;
      if (this.mail.name == "") {
        this.background.name = "border border-2 border-danger";
        re = false;
      } else {
        this.background.name = "border border-2 border-success";
      }
      if (this.mail.email == "") {
        this.background.email = "border border-2 border-danger";
        re = false;
      } else {
        this.background.email = "border border-2 border-success";
      }
      if (this.mail.message == "") {
        this.background.message = "border border-2 border-danger";
        re = false;
      } else {
        this.background.message = "border border-2 border-success";
      }
      if (this.mail.datenschutz == false) {
        this.background.datenschutz = "bg-danger";
        re = false;
      } else {
        this.background.datenschutz = "bg-success";
      }

      return re;
    },
    sendMail() {
      if (this.checkEingaben()) {
        const axiosConfig = {
          headers: {
            Accept: "text/plain",
            "Content-Type": "text/plain",
          },
        };
        const payload = {
          //empfaenger: "joerg@pillar.de",
          empfaenger: "info@weinhaus-eberitzsch.de",
          name: this.mail.name,
          email: this.mail.email,
          telefon: this.mail.telefon,
          text: this.mail.message,

          datenschutz: this.mail.datenschutz,
        };
        let mail = this.mail;
        let background = this.background;
        axios
          .post("https://pillar.de/mailrelay/post_attachment.php", payload, axiosConfig)
          .then((response) => {
            console.log("success", response.data);
            mail.gesendet = "Ihre Kontaktdaten wurden erfolgreich versendet";
            mail.name = "";
            background.name = "";
            mail.email = "";
            background.email = "";
            mail.message = "";
            background.message = "";
            mail.datenschutz = false;
            background.datenschutz = "";
            mail.telefon = "";
            background.telefon = "";
          })
          .catch((error) => {
            console.log(error.response);
            mail.gesendet =
              "Ihre Kontaktdaten konnten leider nicht gesendet werden. Bitte rufen Sie uns an.";
          });
      }
    },
    toggleDdown() {
      this.visi = true;
      setTimeout(() => (this.visi = false), 2000);
    },

    ifAktuell() {
      if (this.activeScreen == "/Kontakt") {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
@media (max-width: 576px) {
  /* SM */
  .form_message_Field {
    width: 290px;
  }
}
@media (min-width: 576px) {
  /* SM */
  .form_message_Field {
    width: 290px;
  }
}
@media (min-width: 768px) {
  /* MD */
  .form_message_Field {
    width: 350px;
  }
}
@media (min-width: 992px) {
  /* LG */
  .form_message_Field {
    width: 350px;
  }
}
@media (min-width: 1200px) {
  /* XL */
  .form_message_Field {
    width: 450px;
  }
}
</style>
